import React from "react";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import styles from "./UserGroup.module.css";

const UserGroup = ({ className = "" }: { className?: string }) => (
    <span className={`${styles.group} ${className}`.trim()}>
        <FontAwesome name="users" className={styles.icon} />
    </span>
);

UserGroup.displayName = "UserGroup";
export default UserGroup;
